// Inline SVGs ported verbatim from the mocks (sq_context_picker_mock.html ICON
// map + sq_thinking_status_mock.html ICON map). Sizing/colour come from the CSS
// module (.chip svg / .opt svg / .step svg), so these carry no dimensions.

import React from "react";

const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };

// Module icons — keyed by canonical module id.
const MODULE_PATHS = {
  issues: <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" {...stroke} />,
  incidents: <path d="M12 2 2 7v6c0 5 4 8 10 9 6-1 10-4 10-9V7L12 2Z" {...stroke} />,
  inspections: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="2" {...stroke} />
      <path d="M9 7h6M9 11h6M9 15h3" {...stroke} />
    </>
  ),
  risk_assessments: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" {...stroke} />,
  ptw: <path d="M14 3v4h4M14 3l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7Z" {...stroke} />,
  tasks: <path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" {...stroke} />,
};

export function ModuleIcon({ canonical }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {MODULE_PATHS[canonical] || MODULE_PATHS.issues}
    </svg>
  );
}

// Org-hierarchy / location chip icon — a map pin (the org filter spans facility → site →
// area → subarea; the tier's tenant label is rendered as text alongside it).
export function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 21s7-6.3 7-11a7 7 0 0 0-14 0c0 4.7 7 11 7 11Z" {...stroke} />
      <circle cx="12" cy="10" r="2.5" {...stroke} />
    </svg>
  );
}

// Date-filter chip icon — a calendar (the sticky From/To + date-option control).
export function CalendarIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="4" width="18" height="17" rx="2" {...stroke} />
      <path d="M3 9h18M8 2v4M16 2v4" {...stroke} />
    </svg>
  );
}

// Thinking-step icons — keyed by the `icon` hint on a phase event.
const STEP_NODES = {
  search: (
    <>
      <circle cx="11" cy="11" r="7" {...stroke} />
      <path d="M21 21l-4.3-4.3" {...stroke} />
    </>
  ),
  read: <path d="M3 5a2 2 0 0 1 2-2h6v18H5a2 2 0 0 1-2-2V5zM21 5a2 2 0 0 0-2-2h-6v18h6a2 2 0 0 0 2-2V5z" {...stroke} />,
  chart: <path d="M3 3v18h18M7 14l3-3 3 3 4-5" {...stroke} />,
  spark: <path d="M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6L12 2z" fill="currentColor" />,
};

export function StepIcon({ icon }) {
  const node = STEP_NODES[icon] || STEP_NODES.spark;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {node}
    </svg>
  );
}

// The animated sparkle in the "Thinking…" header (fill, like the mock).
export function Sparkle({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6L12 2z" />
    </svg>
  );
}
